var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Modal", { attrs: { isOpen: _vm.isOpen } }, [
    _c("div", { staticClass: "proceed-to-pay-wrapper" }, [
      _c("img", {
        attrs: {
          width: "72",
          height: "72",
          src: require("@static/img/proceedToPay.svg"),
          alt: "proceed-to-pay-icon"
        }
      }),
      _c("p", { staticClass: "title", attrs: { "data-testid": "headtitle" } }, [
        _vm._v("Proceed to Pay")
      ]),
      _c(
        "p",
        {
          staticClass: "subtitle font-16",
          attrs: { "data-testid": "subtitle" }
        },
        [_vm._v("By clicking confirm, you continue with the payment")]
      ),
      _c(
        "div",
        { staticClass: "btn-wrapper" },
        [
          _c(
            "EpButton",
            {
              staticClass: "btn confirm",
              attrs: { "data-testid": "confirm-button" },
              on: { click: _vm.handleConfirm }
            },
            [_vm._v("Confirm")]
          ),
          _c(
            "EpButton",
            {
              staticClass: "btn discard",
              attrs: { "data-testid": "discard-button" },
              on: { click: _vm.handleDiscard }
            },
            [_vm._v("Discard")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }